import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiService } from '@services/api/api.service';
import { ProjectService } from '@services/api/project.service';
import { SharedService } from '@services/api/shared.service';
import { TaskService } from '@services/api/task.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { FormHelper } from '@services/helpers/form-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ReduxService } from '@state-management/redux.service';
import { ToastrService } from 'ngx-toastr';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { environment } from 'src/environments/environment';
import { DashService } from '../../dash-board/dash.service';

@Component({
  selector: 'app-create-new-task',
  templateUrl: './create-new-task.component.html',
  styleUrls: ['./create-new-task.component.scss'],
})
export class CreateNewTaskComponent implements OnInit {
  @Input() isContact: any;
  @Input() property_id: any;
  @Input() lead_id: any;
  @Input() leadDetail: any;
  @Input() task_detail: any;
  @Input() task_type: string = null;
  @Output() isUpdated = new EventEmitter<any>();
  @Output() isTaskCreate = new EventEmitter<boolean>();
  @Output() isContactUpdate = new EventEmitter<any>();
  @Output() IsTaskSaved: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() IsSavedClosed: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  S3Path = environment.S3 + '/';
  minDate = new Date();
  leads: any;
  projects: any;
  apartments: any;
  createTaskForm: FormGroup;
  submitted: boolean = false;
  jobTypes: any;
  taskStatuses: any;
  categories: any;
  properties: any;
  priorities: any;
  originalAssigns: any;
  localUser: any = [];
  bill: any;
  uploadedFile: any = [];
  submit_btn_disabled = false;
  times = [];
  public userPermission = Crypto.decrypt(this.localStorageService.GetItem('_per'));
  public userRole = Crypto.decrypt(this.localStorageService.GetItem('role'));
  public GroupFormData = new FormData();
  public logoUrl = [];
  public logos = null;

  error = null;
  checkList = [];
  dropdown_options = [
    { name: 'Contact', value: 'contact' },
    { name: 'Listing', value: 'property' },
    // { name: 'Lead Management', value: 'lead_management' },
    { name: 'Property', value: 'properties' },
    { name: 'Project', value: 'project' },
    { name: 'Other', value: 'other' },
  ];
  reminder_options = [
    'none',
    '0 minutes',
    '5 minutes',
    '10 minutes',
    '15 minutes',
    '30 minutes',
    '1 hour',
    '2 hours',
    '3 hours',
    '4 hours',
    '5 hours',
    '6 hours',
    '7 hours',
    '8 hours',
    '9 hours',
    '10 hours',
    '11 hours',
    '0.5 days',
    '18 hours',
    '1 day',
    '2 days',
    '3 days',
    '4 days',
    '1 week',
    '2 weeks',
  ];
  timer_options = [
    '9am',
    '9:30am',
    '10am',
    '10:30am',
    '11am',
    '11:30am',
    '12pm',
    '12:30pm',
    '1pm',
    '1:30pm',
    '2pm',
    '2:30pm',
    '3pm',
    '3:30pm',
    '4pm',
    '4:30pm',
    '5pm',
    '5:30pm',
    '6pm',
    '6:30pm',
    '7pm',
    '7:30pm',
    '8pm',
    '8:30pm',
    '9pm',
    '9:30pm',
    '10pm',
    '10:30pm',
    '11pm',
    '11:30pm',
    '12am',
    '12:30am',
    '1am',
    '1:30pm',
    '2am',
    '2:30am',
    '3am',
    '3:30am',
    '4am',
    '4:30am',
    '5am',
    '5:30am',
    '6am',
    '6:30am',
    '7am',
    '7:30am',
    '8am',
    '8:30am',
  ];

  newItem = '';
  checkItemToEdit = null;
  subscription: any;
  showLeads = false;
  isJobTypeDisable: boolean = false;
  start_date_model = new Date();
  canUpdate = false;
  InsertedId = null;
  constructor(
    public lmService: LeadManagementService,
    public projectService: ProjectService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private formHelper: FormHelper,
    private _taskService: TaskService,
    private _sharedService: SharedService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private toast: ToastrService,
    private api: ApiService,
    private _mobileService: DashService,
    private redux: ReduxService,
    private remmiConfirm: RemmiConfirmService
  ) {
    for (let hr = 0; hr < 24; hr++) {
      let zone = hr < 12 ? 'AM' : 'PM';
      let clock = hr > 12 ? hr % 12 : hr;
      let shr = clock < 10 ? '0' + clock : clock;
      shr = shr == '00' ? '12' : shr;
      let vhr = hr < 10 ? '0' + hr : hr;
      this.times.push({ label: shr + ':00 ' + zone, value: vhr + ':00' });
      this.times.push({ label: shr + ':30 ' + zone, value: vhr + ':30' });
    }
  }

  created_date: any;
  isMobileDevice = false;
  show_filter = false;
  // ngOnInit lifecycle hook - initializes the component and triggers necessary actions
  async ngOnInit() {
    // Set the created date to the current date
    this.created_date = new Date();

    // Call function to fetch all tasks
    this.getAllTasks();

    // Await the result of getCreatingUser function to ensure it completes before proceeding
    await this.getCreatingUser();

    // Call function to get office staff details
    this.getOfficeStaff();

    // Call function to create the form
    this.createForm();

    // Fetch job types from task service and sort them by name
    this._taskService.getTypes({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        // Sort job types alphabetically by name
        this.jobTypes = response.data?.sort((a, b) => a?.name.localeCompare(b?.name));

        // If job types exist, handle the specific logic for setting the job type
        if (this.jobTypes?.length) {
          // Find the "Lead Management" job type if available
          let findJobType = this.jobTypes.find(itm => {
            return itm.name === 'Lead Management';
          });

          // If a lead_id is present and the "Lead Management" job type is found, set related flags
          if (this.lead_id && findJobType) {
            this.showLeads = true;
            this.isJobTypeDisable = true;
          } else {
            // If no lead_id or "Lead Management" job type, use the first available job type
            findJobType = this.jobTypes[0];
          }

          // Set the value of the job type control in the form
          this.createTaskForm.controls['job_type_id'].setValue(findJobType?._id);
        }
      },
    });

    // Fetch task priorities from task service and set the default priority in the form
    this._taskService.getPriorities({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        this.priorities = response.data;

        // Set the default priority in the form
        this.createTaskForm.patchValue({ priority_id: this.priorities[0]._id });
      },
    });

    // Fetch task statuses from task service and set the default status in the form
    this._taskService.getStatuses({ office_id: this.api.getOfficeId() }).subscribe({
      next: response => {
        this.taskStatuses = response.data;

        // If task statuses exist, set the first status as default
        if (this.taskStatuses?.length) {
          let findStatus = this.taskStatuses[0];
          this.createTaskForm.controls['task_status_id'].setValue(findStatus?._id);
        }
      },
    });

    // Call function to get entity leads
    this.getEntityLeads();

    // Patch the form with task details, including title, due date, assigned users, task time, and reminder
    this.createTaskForm.patchValue({
      title: this.task_detail.title,
      due_date: this.task_detail.due_date ? new Date(this.task_detail.due_date) : null,
      assignedUsers: this.task_detail.assignedUsers,
      task_time: this.task_detail.task_time || '9am',
      reminder: '15 minutes',
    });

    // Subscribe to screen size changes and toggle mobile view based on width
    this._mobileService?.screenSize$?.subscribe({
      next: size => {
        // If the screen width is less than 667px, set the mobile toggle to true, else false
        if (size.width < 667) {
          this.isMobileDevice = true;
        } else {
          this.isMobileDevice = false;
        }
      },
    });
  }

  task_list: any[] = [];
  // Function to fetch all tasks with specific parameters and filters
  getAllTasks() {
    // Define search parameters for the task API call
    let search = {
      page_no: null, // Page number (if pagination is needed)
      per_page: null, // Number of tasks per page
      keyword: null, // Search keyword (if searching tasks by name or other criteria)
      agent: null, // Filter tasks by agent (optional)
      job_type: null, // Filter tasks by job type (optional)
      status: null, // Filter tasks by status (optional)
      due_date: null, // Filter tasks by due date (optional)
      only: 'all', // Specify the type of tasks (e.g., 'all' tasks)
      is_short: true, // Flag to indicate if only short tasks are needed
      office_id: this.api.getOfficeId(), // Office ID filter
      user_id: this.api.getUserId(), // User ID filter
    };

    // Send a GET request to fetch tasks based on the search parameters
    this.api.get('/tasks?show=all&include=user,assignToUsers,assigns,taskStatus,jobType,property,taskAppraisal', search).subscribe({
      next: response => {
        // Initialize an empty task list
        this.task_list = [];

        // Map through the response data and add a formatted `task_title` for each task
        this.task_list = response?.data?.map(el => {
          el = { ...el, task_title: el?.id + ' | ' + el?.title }; // Create a custom task title
          return el;
        });
      },
    });
  }

  // ngOnDestroy lifecycle hook to clean up resources when the component is destroyed
  ngOnDestroy() {
    // Unsubscribe from any active subscriptions to prevent memory leaks
    this.subscription.unsubscribe();
  }

  // Function to create the task form using FormBuilder
  createForm() {
    // Define the default form structure for the task
    let frm = {
      is_later: [0], // Field for task delay option
      title: ['', Validators.required], // Task title with required validator
      assignedUsers: [[], Validators.required], // Assigned users with required validator
      assignedTeams: [[]], // Assigned teams (optional)
      job_type_id: [null], // Job type ID (optional)
      start_date: ['', Validators.required], // Start date with required validator
      due_date: ['', Validators.required], // Due date with required validator
      task_status_id: [null], // Task status ID (optional)
      property_id: [null], // Property ID (optional)
      properties_id: [null], // Properties ID (optional)
      task_category_id: [null], // Task category ID (optional)
      priority_id: [null], // Priority ID (optional)
      description: [''], // Task description (optional)
      isRecurring: [null], // Recurrence flag (optional)
      recurringType: [null], // Recurrence type (optional)
      recurringEnds: [null], // Recurrence end date (optional)
      logos: [], // Logos associated with the task (optional)
      office_id: [null], // Office ID (optional)
      task_check_list: [''], // Task checklist (optional)
      lead_id: [null], // Lead ID (optional)
      SaveToGoogleCalendar: [null], // Save to Google Calendar flag (optional)
      contact_id: [null], // Contact ID (optional)
      project_id: [null], // Project ID (optional)
      apartment_id: [null], // Apartment ID (optional)
      property_project_type: [null], // Property or project type (optional)
      task_time: [null], // Task time (optional)
      parent_id: [null], // Parent task ID (optional)
      reminder: null, // Reminder flag (optional)
      time_zone: [Intl.DateTimeFormat().resolvedOptions().timeZone], // Time zone with default system time zone
    };

    // Check if lead_id exists, adjust form fields accordingly
    if (this.lead_id) {
      frm = {
        is_later: [0], // Field for task delay option
        title: ['', Validators.required], // Task title with required validator
        assignedUsers: [[], Validators.required], // Assigned users with required validator
        assignedTeams: [[]], // Assigned teams (optional)
        job_type_id: [null], // Job type ID (optional)
        start_date: ['', Validators.required], // Start date with required validator
        due_date: ['', Validators.required], // Due date with required validator
        task_status_id: [null], // Task status ID (optional)
        property_id: [null], // Property ID (optional)
        properties_id: [null], // Properties ID (optional)
        task_category_id: [null], // Task category ID (optional)
        priority_id: [null], // Priority ID (optional)
        description: [''], // Task description (optional)
        isRecurring: [null], // Recurrence flag (optional)
        recurringType: [null], // Recurrence type (optional)
        recurringEnds: [null], // Recurrence end date (optional)
        logos: [], // Logos associated with the task (optional)
        office_id: [null], // Office ID (optional)
        task_check_list: [''], // Task checklist (optional)
        SaveToGoogleCalendar: [null], // Save to Google Calendar flag (optional)
        lead_id: [this.lead_id], // Set the lead ID if available
        contact_id: [''], // Contact ID (set to empty string initially)
        project_id: [null], // Project ID (optional)
        apartment_id: [null], // Apartment ID (optional)
        parent_id: [null], // Parent task ID (optional)
        property_project_type: [null], // Property or project type (optional)
        task_time: null, // Task time (optional)
        reminder: null, // Reminder flag (optional)
        time_zone: [Intl.DateTimeFormat().resolvedOptions().timeZone], // Time zone with default system time zone
      };

      // Adjust form based on lead details (if available)
      if (this.leadDetail) {
        // Check if the lead has project or property details, and adjust the form accordingly
        if (this.leadDetail?.project) {
          frm['property_project_type'] = ['project']; // Set to "project" if the lead has project
        } else if (this.leadDetail?.property) {
          frm['assignedUsers'] = [this.leadDetail.agent]; // Assign agent to users if the lead has property
          frm['property_project_type'] = ['property']; // Set to "property" if the lead has property
        }
      }
    }

    // Create the form group with the defined form structure
    this.createTaskForm = this.fb.group(frm);

    // Adjust form based on task type (Contact, Property, Lead, etc.)
    if (this.task_type == 'Contact') {
      // Check if contact exists in the service and patch form value
      this.createTaskForm.patchValue({
        property_project_type: 'contact', // Set to "contact"
        contact_id: [this.property_id], // Set contact ID to null if not found
      });
    } else if (this.task_type == 'Property') {
      // Set property values for property task type
      this.createTaskForm.patchValue({
        property_project_type: 'property', // Set to "property"
        property_id: [this.property_id], // Set property ID
      });
    } else if (this.task_type == 'Lead') {
      // Set lead values for lead task type
      this.createTaskForm.patchValue({
        property_project_type: 'lead', // Set to "lead"
        lead_id: this.property_id, // Set lead ID
      });
    } else if (this.task_type == 'project') {
      // Set project values for project task type
      this.createTaskForm.patchValue({
        property_project_type: 'project', // Set to "project"
        project_id: [this.property_id], // Set project ID
      });
    } else if (this.task_type == 'properties') {
      // Set properties values for properties task type
      this.createTaskForm.patchValue({
        property_project_type: 'properties', // Set to "properties"
        properties_id: [this.property_id], // Set properties ID
      });
    }

    // Set start date in the form
    this.createTaskForm.patchValue({
      start_date: this.start_date_model, // Set start date from the model
    });
  }

  onUpdateMSelect = (eve: any, type: string) => {
    // let ids = type === 'project_id' ? [eve] : eve?.length > 0 ? eve.map(f => f._id) : null;
    let ids = eve?.length > 0 ? eve.map(f => f._id) : null;
    this.createTaskForm.patchValue({ [type]: ids });
  };

  attachments: any[] = [];
  onSubmit(state) {
    // Disable the submit button to prevent multiple submissions
    this.submit_btn_disabled = true;

    // Patch values for office_id and start_date in the form
    this.createTaskForm.patchValue({
      office_id: this.api.getOfficeId(),
      start_date: new Date(),
    });

    // If not later, set "is_later" flag to 0, mark the form as submitted, and validate the form
    this.createTaskForm.controls['is_later'].setValue(0);
    this.submitted = true;
    this.formHelper.validateAllFormFields(this.createTaskForm);

    // Create an array of fields with invalid status
    let fields: any = Object.entries(this.createTaskForm.controls)
      .reduce((acc, [key, value]) => {
        if (value.status === 'INVALID') {
          acc.push(this.formalFields.find(errorfield => errorfield.name === key) || undefined);
        }
        return acc;
      }, [])
      ?.filter(result => result !== undefined && result !== null);

    // Revalidate all form fields
    this.formHelper.validateAllFormFields(this.createTaskForm);

    // If invalid fields found, validate them on request
    fields && this.validateFieldsOnRequest(fields);

    // If the form is not valid, re-enable the submit button and return
    if (!this.createTaskForm.valid) {
      this.submit_btn_disabled = false;
      return;
    }

    // Patch values for project_id and apartment_id based on property_project_type
    if (this.createTaskForm.get('property_project_type').value == 'property') {
      this.createTaskForm.patchValue({ project_id: null, apartment_id: null });
    } else if (this.createTaskForm.get('property_project_type').value == 'properties') {
      this.createTaskForm.patchValue({ project_id: null, apartment_id: null });
    } else {
      if (this.createTaskForm.get('property_project_type').value == 'contact') {
        this.createTaskForm.patchValue({ project_id: null, apartment_id: null });
      } else {
        this.createTaskForm.patchValue({ property_id: null, contact_id: null });
      }
    }

    // If logos are not null, patch the logos value into the form
    if (this.logos !== null) {
      this.createTaskForm.patchValue({ logos: this.logos });
    }

    // Check if the title is empty and display an error if it is
    if (!this.createTaskForm.get('title').value.trim()) {
      this.toast.error('Please enter a valid title');
      this.createTaskForm.controls['title'].setValue(null);
      this.submit_btn_disabled = false;
      this.submitted = false;
      return;
    }

    // Patch the task_check_list field if any checklist exists
    let checkList = this.checkList?.length > 0 ? JSON.stringify(this.checkList) : null;
    this.createTaskForm.patchValue({ task_check_list: checkList });

    // If updating an existing task, make a PUT request
    if (this.canUpdate == true && this.InsertedId != null) {
      let form_data = this.createTaskForm.value;

      // Determine if the task is a sub-task based on the parent_id
      form_data['is_sub_task'] =
        this.createTaskForm.controls['parent_id'].value && this.createTaskForm.controls['parent_id'].value !== 'null' ? true : false;

      // Perform the PUT request to update the task
      this._taskService.updateTask(this.InsertedId, form_data).subscribe({
        next: response => {
          this.IsSavedClosed.emit(true);

          // Wait for a moment to set the attachments value
          setTimeout(() => (this.attachments = response?.info?.value?.attachments), 2000);

          // Clear logos and reset state
          this.logoUrl = [];
          this.logos = [];

          // Handle success based on the state (e.g., whether to save only or also close)
          if (state !== 'onlySave') {
            this.IsSavedClosed.emit(false);
            this.lmService.is_new_task = false;
            this.createTaskForm.reset();
            this.closeAddTask();
            this.toast.success('Task updated');
            this.submit_btn_disabled = this.submitted = false;
          } else {
            this.submit_btn_disabled = false;
            this.toast.success('Task updated');
            this.canUpdate = true;
          }

          // Reset validation error tracking
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        },
        error: error => {
          // On error, re-enable the submit button
          this.submit_btn_disabled = false;

          // Handle field-specific errors
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            this.formalFields = fields = fields
              ?.map(error_field => {
                let isExistsField = all_fields?.find(field => field.name === error_field);
                if (isExistsField) {
                  error_field = { name: error_field, label: isExistsField?.label || '' };
                }
                return error_field;
              })
              ?.filter(error_field => error_field !== undefined && error_field !== null && typeof error_field !== 'string');

            this.toast.error('Required fields must be filled in');
            this.validateFieldsOnRequest(fields);
          } else {
            // If no fields, show a general error message
            this.toast.error(error.error['message']);
          }
        },
      });
    } else {
      // If not updating (creating new task), make a POST request
      let form_data = this.createTaskForm.value;
      form_data['is_sub_task'] =
        this.createTaskForm.controls['parent_id'].value && this.createTaskForm.controls['parent_id'].value !== 'null' ? true : false;

      // Perform the POST request to create a new task
      this._taskService.createTask(form_data).subscribe({
        next: response => {
          this.IsSavedClosed.emit(true);

          // Wait for a moment to set the attachments value
          setTimeout(() => (this.attachments = response?.attachments), 2000);

          // Clear logos and reset state
          this.logoUrl = [];
          this.logos = [];

          // Handle success based on the state (e.g., whether to save only or also close)
          if (state !== 'onlySave') {
            this.IsSavedClosed.emit(false);
            this.lmService.is_new_task = false;
            this.createTaskForm.reset();
            this.closeAddTask();
            this.toast.success('Task created');
            this.submit_btn_disabled = this.submitted = false;
          } else {
            this.submit_btn_disabled = false;
            this.toast.success('Task created');
            this.canUpdate = true;
            this.InsertedId = response.InsertedId;
          }

          // Reset validation error tracking
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
        },
        error: error => {
          // On error, re-enable the submit button
          this.submit_btn_disabled = false;

          // Handle field-specific errors
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            this.formalFields = fields = fields
              ?.map(error_field => {
                let isExistsField = all_fields?.find(field => field.name === error_field);
                if (isExistsField) {
                  error_field = { name: error_field, label: isExistsField?.label || '' };
                }
                return error_field;
              })
              ?.filter(error_field => error_field !== undefined && error_field !== null && typeof error_field !== 'string');

            this.toast.error('Required fields must be filled in');
            this.validateFieldsOnRequest(fields);
          } else {
            // If no fields, show a general error message
            this.toast.error(error.error['message']);
          }
        },
      });
    }
  }

  getOfficeStaff() {
    // Constructs the URL to get the office staff based on the current office ID
    let url = '/users/byoffice?office=' + this.api.getOfficeId() + '&show=staff';

    // Calls the Redux service to fetch the office staff data
    this.redux.getSetProjectInfo(false, 'byOffice', url).subscribe({
      next: response => {
        // Maps the retrieved staff data and creates a deep copy of the response data
        this.originalAssigns = JSON.parse(JSON.stringify(response.data));

        // Checks if the current local user is not in the staff list, then adds them
        if (!this.originalAssigns.some(user => user._id === this.localUser._id)) {
          this.originalAssigns.push(this.localUser);
        }

        // Constructs the full name for each staff member by combining first and last names
        this.originalAssigns = this.originalAssigns.map(i => {
          i.full_name = i.first_name + ' ' + i.last_name;
          return i;
        });

        // Sorts the staff members alphabetically by their full names
        this.originalAssigns.sort((a, b) => a.full_name.localeCompare(b.full_name));

        // If the user is not a 'master admin', set the default assigned users for the task
        if (Crypto.decrypt(this.localStorageService.GetItem('role')) != 'master admin') {
          let val = this.task_detail?.assignedUsers?.length > 0 ? this.task_detail?.assignedUsers : [this.api.getUserId()];
          this.createTaskForm.controls['assignedUsers'].setValue(val);
        }
      },
    });
  }

  getCreatingUser() {
    // Makes a GET request to fetch the user details by user ID
    this._taskService.getTaskCreatingUser().subscribe({
      next: response => {
        // Sets the 'localUser' object to the fetched user data
        this.localUser = response?.data;
      },
    });
  }
  allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
  onLogoSelect(event) {
    // Checks if logos array is null, and initializes empty arrays if needed
    if (this.logos == null) {
      this.logos = [];
      this.logoUrl = [];
    }

    // Checks if files are selected
    if (event.target.files && event.target.files.length) {
      // Loops through each selected file
      for (let i = 0; i < event.target.files.length; i++) {
        let logoName = event.target.files[i].name;
        const file = event.target.files[i];
        // ✅ Validate file type
        if (!this.allowedTypes.includes(file.type)) {
          this.toast.error(`Unsupported file format! Please upload a valid image`);
          continue; // Skip invalid files
        }
        const fileReader: FileReader = new FileReader();
        fileReader.readAsDataURL(event.target.files[i]); // Reads the file as data URL
        fileReader.onload = () => {
          // Pushes the sanitized URL and logo file into the respective arrays
          this.logoUrl.push(this.sanitizer.bypassSecurityTrustUrl(<any>fileReader.result));
          this.logos.push({ name: logoName, file: fileReader.result });
        };
      }
    }
  }

  onJobType() {
    // Sets showLeads to false by default
    this.showLeads = false;

    // Loops through the job types and checks if the job type is "Lead Management"
    this.jobTypes.forEach(jt => {
      if (jt.name == 'Lead Management' && jt._id == this.createTaskForm.controls['job_type_id'].value) {
        this.showLeads = true; // Shows leads if the condition is met
      }
    });
  }

  getEntityLeads() {
    // Make an API call to fetch leads related to the entity
    this._sharedService.getDropDownItems('leads').subscribe({
      next: response => {
        // Store the fetched leads data in the 'leads' variable
        this.leads = response['data'];
      },
    });
  }

  onChangeProject(event) {
    // Calls the getApartmentByProject function when a project is changed
    this.getApartmentByProject(event);
  }

  getApartmentByProject(projectid) {
    // Makes a GET request to fetch apartments based on the given project ID
    this._taskService.getProjectLot(projectid).subscribe({
      next: response => {
        // Sets the apartments data in the component
        this.apartments = response['data'];
      },
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    // Stores the item being moved
    const moveIt = this.checkList[event.previousIndex];

    // Gets the index of the item being moved to
    const withId = event.currentIndex;

    // Swaps the items in the checkList based on their previous and current indices
    this.checkList[event.previousIndex] = this.checkList[withId];
    this.checkList[withId] = moveIt;
  }

  printingTypeSetting(val) {
    // Enables or disables the printing type field based on the value passed
    if (val === 'yes') {
      this.createTaskForm.controls['printing_type_id'].enable();
    } else {
      this.createTaskForm.controls['printing_type_id'].disable();
    }
  }

  QuantityCheck(val) {
    // Checks if the value is "yes" and enables or disables the quantity and other form controls accordingly
    if (val === 'yes') {
      this.createTaskForm.controls['printing_type_id'].setValue(1);
      this.createTaskForm.controls['quantity'].enable();
      this.createTaskForm.controls['isChecked'].enable();
    } else {
      this.createTaskForm.controls['printing_type_id'].setValue(2);
      this.createTaskForm.controls['quantity'].disable();
      this.createTaskForm.controls['quantity'].setValue(0);
      this.createTaskForm.controls['isChecked'].disable();
      this.bill = 0;
    }
  }

  getBill() {
    const form = this.createTaskForm;

    // Ensures the quantity is positive, sets it to the absolute value if negative
    if (form.controls['quantity'].value < 0) {
      form.controls['quantity'].setValue(form.controls['quantity'].value * -1);
    }

    // Filters categories to find the selected one by task category ID
    const myFilter = this.categories.filter(cat => cat.id === form.controls['task_category_id'].value);

    // Checks if the printing cost is zero and displays an error message
    if (myFilter[0].printingCosts === 0) {
      this.toast.error('Please contact your office for printing rates');
    } else {
      // Calls the bill function and calculates the bill based on printing type, category, and quantity
      this._taskService
        .bill(form.controls['printing_type_id'].value, form.controls['task_category_id'].value, form.controls['quantity'].value)
        .subscribe(res => {
          // Applies a discount if available and calculates the final bill
          if (res.discount_percent > 0) {
            const orgBill = res.per_print * form.controls['quantity'].value;
            this.bill = orgBill - (orgBill * res.discount_percent) / 100;
          } else {
            this.bill = res.per_print * form.controls['quantity'].value;
          }

          // Resets the "isChecked" field to false
          form.controls['isChecked'].setValue(false);
        });
    }
  }

  changeQtyBox(action) {
    const filed = this.createTaskForm.controls['quantity'];

    // Increments or decrements the quantity based on the action
    if (action === 'plus') {
      filed.setValue(filed.value + 1);
    } else {
      if (filed.value === 0) {
        filed.setValue(1); // Prevents the quantity from going below 1
      }
      filed.setValue(filed.value - 1);
    }

    // Calls getBill to update the bill after quantity change
    this.getBill();
  }

  propertySelection(row) {
    // Checks if the row is not undefined and makes a POST request with the property data
    if (row !== undefined) {
      this.api.post('/property-address', row).subscribe({ next: () => {} });
    }
  }

  fileReceivedForTask(e) {
    // Iterates over each file received and pushes it into the uploadedFile array
    e.forEach(file => {
      this.uploadedFile.push(file);
    });
  }

  deleteLogo(logo) {
    this.remmiConfirm
      .delete({ title: 'Delete Attachment?', message: 'This file will be permanently deleted from the task.', subject: logo?.name })
      .subscribe(isConfirmed => {
        if (!isConfirmed) {
          return;
        }
        // Finds the index of the logo in the attachments array
        const i = this.attachments.indexOf(logo);

        // Removes the logo from the attachments array
        this.attachments.splice(i, 1);

        // Makes a DELETE request to remove the logo from the server
        this._taskService.deleteTaskLogo(logo._id).subscribe({ next: () => this.toast.success('File has been deleted') });
      });
  }

  addCheckListItem() {
    // If an item is being edited, it updates the checklist item at the specified index
    if (this.checkItemToEdit !== null) {
      this.checkList[this.checkItemToEdit] = this.newItem;
      this.checkItemToEdit = null;
    } else {
      // If no item is being edited, it adds a new item to the checklist
      this.checkList.push(this.newItem);
    }

    // Resets the newItem field to an empty string after adding or editing the item
    this.newItem = '';
  }

  getMinDueDate() {
    // Checks the value of job_type_id and calculates the minimum due date based on specific rules
    if (this.createTaskForm.controls['job_type_id'].value === 2) {
      // Adds 2 days to the start date and adjusts if it's a weekend
      let d = new Date(this.createTaskForm.controls['start_date'].value).getTime() + 86400000 * 2;
      if (new Date(d).getDay() === 6 || new Date(d).getDay() === 0) {
        d = new Date(this.createTaskForm.controls['start_date'].value).getTime() + 86400000 * 4;
      }
      return d;
    } else if (this.createTaskForm.controls['job_type_id'].value === 1 || this.createTaskForm.controls['job_type_id'].value === 12) {
      // Adds 1 day to the start date for certain job types
      let dd = new Date(this.createTaskForm.controls['start_date'].value).getTime() + 86400000;
      return dd;
    } else {
      // Returns the start date without modification for other job types
      let dd = new Date(this.createTaskForm.controls['start_date'].value).getTime();
      return dd;
    }
  }

  onAppraisal() {
    // Sets the showLeads flag based on the selected job type
    this.showLeads = false;
    this.jobTypes.forEach(jt => {
      if (jt.name == 'Lead Management' && jt._id == this.createTaskForm.controls['job_type_id'].value) {
        this.showLeads = true;
      }
    });

    // Sets up form validations based on the selected job type
    if (this.createTaskForm.controls['job_type_id'].value === 6) {
      (this.createTaskForm.get('appraisal') as FormGroup).controls['appraisal_address'].setValidators([Validators.required]);
    } else if (this.createTaskForm.controls['job_type_id'].value === 13 || this.createTaskForm.controls['job_type_id'].value === 2) {
      // Clears the assignedUsers field for specific job types
      this.createTaskForm.controls['assignedUsers'].setValue([]);
    } else {
      (this.createTaskForm.get('appraisal') as FormGroup).controls['appraisal_address'].clearValidators();
    }
  }

  formatDates(event, field) {
    // Formats the date string and updates the corresponding form field
    let val = Utils.getDateStringFormat(event);
    if (field === 'start_date') {
      this.createTaskForm.patchValue({
        start_date: new Date(val),
      });
      // this.start_date_model = new Date(val);
    } else if (field === 'due_date') {
      this.createTaskForm.patchValue({
        due_date: new Date(val),
      });
    } else if (field === 'recurringEnds') {
      this.createTaskForm.patchValue({
        recurringEnds: val,
      });
    }
  }

  closeAddTask() {
    // Calls the removeLevelTab function to handle closing the task tab
    this.removeLevelTab();
  }

  removeLevelTab() {
    // Checks if there are more than one tab level
    if (this.lmService.tab_levels.length > 1) {
      // Finds the task tab level that is currently empty and active
      let taskTabs = this.lmService.tab_levels.find(
        el => el.name.includes('Task') && el.data == null && this.lmService.activeTabIndex == this.lmService.tab_levels.indexOf(el)
      );
      if (taskTabs) {
        // If task tab is found, it updates the tab's taskTabs property and emits an update
        let ind = this.lmService.tab_levels.indexOf(taskTabs);
        taskTabs['taskTabs'] = true;
        this.isUpdated.emit({ level: taskTabs, index: ind });
      } else {
        // Emits an update if no task tab is found
        this.isUpdated.emit(true);
      }
    } else {
      // Finds the task tab when there is only one tab level and updates it
      let tab = this.lmService.tab_levels.find(el => el.name.includes('Task') && el.data == null);
      if (tab) {
        let ind = this.lmService.tab_levels.indexOf(tab);
        tab['taskTabs'] = true;
        console.log('tab', tab);
        this.isUpdated.emit({ level: tab, index: ind });
      } else {
        this.isUpdated.emit(true);
      }
    }
  }

  clearStaff(item, method) {
    // Checks if the method is 'staff'
    if (method == 'staff') {
      let localArray = [];
      localArray = this.createTaskForm.controls['assignedUsers'].value;
      // Loops through the array to find and remove the specified item
      localArray.forEach((x, i) => {
        if (x === item) {
          localArray.splice(i, 1); // Removes the item at index i
        }
      });
      // Updates the assignedUsers field with the modified array
      this.createTaskForm.controls['assignedUsers'].setValue(localArray);
    }
  }

  editRecord(record) {
    this.openRightModal(record, 'edit_contact');
  }

  selectedContact: any;
  currentLeadIndex: any;
  openRightModal(contact, addOrEdit) {
    // Disables the right bar reload before performing any operations
    this.lmService.reload_rightBar = false;

    // Checks if the operation is to edit a contact
    if (addOrEdit == 'edit_contact') {
      // If the mobile toggle is enabled, navigate to the office contact edit page with the contact id as a query parameter
      if (this.isMobileDevice == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: contact?._id } });
      } else {
        // Sets the editing flag in the service and prepares to show the right bar with editing options
        this.lmService.isEdit_show_div = addOrEdit;
        // Sets the name to display, defaulting to full_name if present, otherwise fallbacks to the full_name or an empty string
        let name = contact?.contact?.full_name || contact?.name || '';
        // Adds the contact as a tab in the tab levels of the service
        this.lmService.addTabInLevels(`Contact-${name}`, contact?._id, contact, null, 'contact');
        // Sets the selected contact for further use
        this.selectedContact = contact;
        // Sets the contact ID in the service for reference
        this.lmService.cont_id = contact?._id;
        // Sets the index of the selected contact in the Users array for navigation or other purposes
        this.currentLeadIndex = this.lmService.Users?.indexOf(this.selectedContact);
        // Triggers the display of the right bar after a short timeout
        setTimeout(() => {
          this.lmService.contact_showRightBar = true;
          this.lmService.reload_rightBar = true;
        }, 50);
      }
    }
    // Checks if the operation is to add a new contact
    else if (addOrEdit == 'add_contact') {
      // If the mobile toggle is enabled, navigate to the create new contact page
      if (this.isMobileDevice == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: 'createnew' } });
      } else {
        // Sets the right bar to show the add contact view and adds the new contact as a tab in the tab levels
        this.lmService.contact_showRightBar = addOrEdit;
        this.lmService.addTabInLevels('Contact', 'new');
      }
    }
    // Checks if the operation is related to a staff member
    else if (addOrEdit == 'staff') {
      // Sets the name to display for the staff member, defaulting to full_name if present
      let name = contact?.contact?.full_name ? contact?.contact?.full_name : contact?.full_name ? contact?.full_name : '';
      // Adds the staff as a tab in the tab levels of the service
      this.lmService.addTabInLevels(`Staff-${name}`, contact?._id);
    }
  }

  @ViewChild('createFormElement') formElementRef!: ElementRef;
  notDisplayRequiredMessage: boolean = true;
  numOfNotValidFields: number = 0;
  requiredErrorMessages = [];
  formalFields: { name: string; label: string }[] = [];

  // Validates the specified fields on the request
  validateFieldsOnRequest(fields: any[] = []) {
    // Checks if fields are provided
    if (fields?.length > 0) {
      // For each field, sets it as required and updates its validity
      fields?.forEach(field_error => {
        this.createTaskForm?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.createTaskForm?.controls?.[field_error?.name]?.updateValueAndValidity();
      });

      // Resets the error message and count for invalid fields
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

      // Loops through the form controls and checks for any validation errors
      for (let prop in this.createTaskForm.controls) {
        // If the control has errors, create an error message object for it
        if (this.createTaskForm.controls[prop].errors) {
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(tempfield => tempfield.name === prop)?.label || ''}`,
          };
          // Adds the error message object to the requiredErrorMessages array
          this.requiredErrorMessages.push(fieldReqObj);
          // Increases the count of invalid fields
          this.numOfNotValidFields++;
        }
      }
    }
  }

  // Activates the tab index based on the error message
  ActivateTabIndexByError(message: string) {
    // Splits the message by spaces to identify the field with the error
    let space_separated: string[] = message?.split(' ');

    // Checks if the first part of the message is not empty
    if (space_separated?.[0]?.trim()?.length > 0) {
      let timeout = 0;

      // Based on the field name, sets the property_project_type and adjusts the timeout
      if (space_separated?.[0]?.trim() === 'project_id') {
        this.createTaskForm.patchValue({
          property_project_type: 'project',
        });
        timeout = 1000;
      }

      if (space_separated?.[0]?.trim() === 'properties_id') {
        this.createTaskForm.patchValue({
          property_project_type: 'properties',
        });
        timeout = 1000;
      }

      if (space_separated?.[0]?.trim() === 'contact_id') {
        this.createTaskForm.patchValue({
          property_project_type: 'contact',
        });
        timeout = 1000;
      }

      if (space_separated?.[0]?.trim() === 'property_id') {
        this.createTaskForm.patchValue({
          property_project_type: 'property',
        });
        timeout = 1000;
      }

      // After the timeout, scrolls the element with the corresponding formControlName or name or id to view
      setTimeout(() => {
        const element = this.formElementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
          ? this.formElementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
          : this.formElementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
            ? this.formElementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
            : this.formElementRef.nativeElement.querySelector(`[id="${space_separated?.[0]?.trim()}"]`);

        // If the element exists, scroll it into view
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, timeout);
    }
  }
}
